<template>
  <div class="pages">
    <!-- <div class="page-header">
      <div class="header-icon">
        <img src="@/assets/homepages/logo.png" style="width:100%;height:100%" />
      </div>
    </div> -->
    <header class="navbar-expand-md navbar-light d-print-none">
      <div class="container-xl" style="padding: 0;">
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-menu">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-brand-autodark d-none-navbar-horizontal">
          <a href=".">
            <img src="@/assets/homepages/logo.png" width="180" height="40" alt="Beecargo">
          </a>
        </div>
        <div class="navbar-nav flex-row order-md-last">
          <div class="nav-item d-none d-md-flex">
            <div class="btn-list">
              <img src="@/assets/homepages/car-a.png" width="54" height="36" alt="">
              <img src="@/assets/homepages/car-b.png" width="72" height="48" alt="">
              <img src="@/assets/homepages/car-c.png" width="150" height="80" alt="">
              <img src="@/assets/homepages/logo-title.png" width="417" height="48" style="margin-left: 20px;" alt="">
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="navbar-expand-md">
      <div class="collapse navbar-collapse" id="navbar-menu">
        <div class="navbar navbar-light">
          <div class="container-xl">
            <ul class="navbar-nav">
              <li class="nav-item">
                <a class="nav-link" href="./index.html" >
                  <span class="nav-link-title">首页</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#downloadApp">
                  <span class="nav-link-title">扫码下单</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#teamWork" >
                  <span class="nav-link-title">企业合作案例</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#aboutUs">
                  <span class="nav-link-title">关于我们</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#server">
                  <span class="nav-link-title">定制服务</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="home-pages-style">
      <div class="main" id="home">
        <el-menu :default-active="activeIndex" class="el-menu-demo nav-item d-none d-md-flex me-3" mode="horizontal" text-color="#FFFFFF" active-text-color="#F1BC3F " background-color="rgba(24,24,24,0.4000)" @select="handleSelect">
          <div class="header-menu-item">
            <el-menu-item index="1">首页</el-menu-item>
            <el-menu-item index="2">扫码下单</el-menu-item>
            <el-menu-item index="3">企业合作案例</el-menu-item>
            <el-menu-item index="4">关于我们</el-menu-item>
            <el-menu-item index="5">定制服务</el-menu-item>
          </div>
        </el-menu>
        <div class="caontent-title">
          <div class="text-title">{{contentText.homePages&&contentText.homePages.textTitle}}</div>
          <div class="letter-title">{{contentText.homePages&&contentText.homePages.latterTitle}}</div>
        </div>
      </div>
    </div>
    <download-app ref="downloadApp" :contentText="contentText" id="downloadApp"></download-app>
    <team-work ref="teamWork" :contentText="contentText" id="teamWork"></team-work>
    <advant ref="advant" :contentText="contentText" id="advant"></advant>
    <about-us ref="aboutUs" :contentText="contentText" id="aboutUs"></about-us>
    <server ref="server" :contentText="contentText" id="server"></server>
    <link-phone ref="linkPhone" :contentText="contentText" id="linkPhone"></link-phone>
    <div class="right-btn" v-if="showRightBtn">
      <div class="suspension-icon back-top" id="backTop" @click="backTopHandle">
        <div class="suspension-icon-item-icon">
          <img src="@/assets/homepages/back-top-icon.png" style="width:100%;height:100%" />
        </div>
        <div class="name">返回顶部</div>
      </div>
      <div class="suspension-icon online-customer-service-icon" id="onlineCustomerService" @click="linkServerHandle" v-show="showLinkServe">
        <!-- <div class="suspension-icon online-customer-service-icon" id="onlineCustomerService" @click="linkServerHandle"> -->
        <div class="suspension-icon-item-icon">
          <img src="@/assets/homepages/online-customer-service-icon.png" style="width:100%;height:100%" />
        </div>
        <div class="name">在线客服</div>
      </div>
    </div>
    <div v-if="showCustomerService">
      <customer-service ref="customerService" />
    </div>
  </div>
</template>

<script>
import customerService from '@/views/contactUs/customerService';
import downloadApp from '@/views/downloadAPP/index.vue';
import teamWork from '@/views/teamWork/index.vue';
import advant from '@/views/advant/index.vue';
import aboutUs from '@/views/aboutUs/index.vue';
import server from '@/views/server/index.vue';
import linkPhone from '@/views/contactUs/linkPhone/index.vue';
import beecargoOfficialWebText from '@/utils/beecargoOfficialWebText.json';
export default {
  components: { customerService, downloadApp, teamWork , advant, aboutUs, server , linkPhone },
  data() {
    return {
      activeIndex: '1',
      showCustomerService: false,
      contentText: beecargoOfficialWebText,
      navList: ['home', 'downloadApp','teamWork' , 'aboutUs', 'server' , 'linkPhone'],
      windowHeight: '',
      showRightBtn: false,
      showLinkServe: true,
    }
  },
  computed: {
    imgUrl() {
      console.log('rocess.env.VUE_APP_STATIC_IMG', process.env.VUE_APP_STATIC_IMG);
      return process.env.VUE_APP_STATIC_IMG
    },
  },
  created() {
    this.windowHeight = document.documentElement.clientHeight
  },
  // 监听滚动事件
  mounted() {
    window.addEventListener('scroll', this.scrollHandle, true);
    // this.createJsText();  //外部引入文件
  },
  // 销毁监听滚动事件
  destroyed() {
    window.addEventListener('scroll', this.scrollHandle, false)
  },
  methods: {
    createJsText() {
      return new Promise((resolve) => {
        const textScript = document.createElement('script');
        textScript.type = 'text/javascript';
        textScript.src = `${process.env.VUE_APP_STATIC_JS}/beecargoOfficialWebText.js`;
        document.body.appendChild(textScript);
        textScript.onload = () => {
          console.log('total_data', total_data)
          this.contentText = total_data
          console.log('this.contentText',this.contentText);
          resolve();
        }
      })
    },
    // 获取滚动高度
    scrollHandle() {
      let scrollTop = document.documentElement.scrollTop
      if (this.windowHeight - 200 < scrollTop) {
        this.showRightBtn = true
      } else {
        this.showRightBtn = false
      }
    },
    // 点击头部导航栏跳转到相应位置
    handleSelect(key, keyPath) {
      this.navList.map((item, index) => {
        if (index + 1 == key) {
          this.getElement(`#${item}`).scrollIntoView({
            behavior: 'smooth'
          })
        }
      })
    },
    getElement(name) {
      return document.querySelector(name);
    },
    backTopHandle() {
      // this.getElement('.pages').scrollIntoView({
      //   behavior: 'smooth'
      // })
      window.scrollTo({top:0,behavior: 'smooth'})
    },
    linkServerHandle() {
      this.showCustomerService = true
      this.$Loading()
      setTimeout(() => {
        this.showLinkServe = false
      }, 1000);
    }
  }
}
</script>
<style>
* {
  padding: 0;
  margin: 0;
}
</style>

<style lang='scss' scoped>
.container-xl {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.btn-list {
  display: flex;
  align-items: flex-end;
  position: relative;
  top: -.1rem;
}
.home-pages-style {
  height: 997px;
  background: url('../../assets/homepages/home-page-background.png') no-repeat;
  background-size: 100% 100%;
  .main {
    width: 100%;
    .el-menu-demo {
      width: 100%;
      height: 88px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .header-menu-item {
        display: flex;
        .el-menu-item {
          font-family: PingFangSC;
          padding: 0 40px;
          font-size: 20px;
        }
      }
    }

    .caontent-title {
      padding-top: 120px;
      margin-left: 360px;
      text-align: left;
      .text-title {
        font-size: 60px;
        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
      }
      .letter-title {
        font-size: 40px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #f1bc3f;
      }
    }
  }
}
.right-btn {
  position: fixed;
  right: 0;
  top: 80vh;
  z-index: 9;
}
.suspension-icon {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  // width: 150px;
  padding: 10px 20px;
  // height: 54px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.08);
  border-radius: 16px 0px 0px 16px;
  opacity: 1;
}
.back-top {
}
.online-customer-service-icon {
  // top: 90vh;
  margin-top: 40px;
}

.suspension-icon-item-icon {
  width: 24px;
  height: 24px;
  font-size: 0;
}
.name {
  margin-left: 15px;
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #7b7b7b;
}
.el-menu-item {
  background: none !important;
  font-size: 18px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
}
.el-menu.el-menu--horizontal {
  border: none;
}
</style>